<template>
  <a-locale-provider :locale="zhCN">
    <div class="add-passenger">
      <a-form :form="form">
        <a-row>
          <div v-if="showPassengerName()">
            <a-col :span="12">
              <a-form-item
                style="height: 61px;"
                label="姓名"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'passengerName',
                      {
                        initialValue: initPassengerName,
                        rules: [
                          { required: showPassengerName(), message: '请填写姓名' },
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  :disabled="showSplitName()"
                  placeholder="请输入姓名"
                >
                <passenger-tooltip slot="addonAfter" v-if="getPassengerFieldInfo('fullName')" :data="getPassengerFieldInfo('fullName')"></passenger-tooltip>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item></a-form-item>
            </a-col>
          </div>
          <div v-if="showSplitName()">
            <a-col :span="12">
              <a-form-item
                style="height: 61px;"
                label="中文姓"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'passengerLastName',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入姓"
                  @blur="onNameChange($event, 'passengerLastName', 'lastName')"
                >
                  <passenger-tooltip slot="addonAfter" v-if="getPassengerFieldInfo('surnameCn')" :data="getPassengerFieldInfo('surnameCn')"></passenger-tooltip>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="中文名"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'passengerFirstName',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入名"
                  @blur="onNameChange($event, 'passengerFirstName', 'firstName')"
                >
                  <passenger-tooltip slot="addonAfter" v-if="getPassengerFieldInfo('nameCn')" :data="getPassengerFieldInfo('nameCn')"></passenger-tooltip>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="英文/拼音姓"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'lastName',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入英文/拼音姓（LAST NAME）"
                >
                  <passenger-tooltip slot="addonAfter" v-if="getPassengerFieldInfo('lastName')" :data="getPassengerFieldInfo('lastName')"></passenger-tooltip>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="英文/拼音名"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'firstName',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入英文/拼音名（FIRST NAME）"
                >
                  <passenger-tooltip slot="addonAfter" v-if="getPassengerFieldInfo('firstName')" :data="getPassengerFieldInfo('firstName')"></passenger-tooltip>
                </a-input>
              </a-form-item>
            </a-col>
          </div>
          <a-col :span="12">
            <a-form-item
              label="旅客类型"
              required
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <a-select
                v-decorator="[
                    'passengerType',
                    {
                      initialValue: 'ADT',
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'change'
                    }
                  ]"
                :size="size"
                @blur="onPTypeChange"
              >
                <a-select-option value="ADT">成人</a-select-option>
                <a-select-option value="CHD">儿童</a-select-option>
                <a-select-option value="INF">婴儿</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="出生日期"
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <a-date-picker
                style="width: 100%;"
                v-decorator="[
                    'birthday',
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'change'
                    }
                  ]"
                :size="size"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="国籍"
              required
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }">
              <a-select
                v-decorator="[
                  'nationality',
                  {
                    rules: [
                      {
                        validator: handleFieldValidate
                      }
                    ],
                    validateTrigger: 'change'
                  }
                ]"
                size="large"
                show-search
                :filter-option="filterOption"
                :options="renderedOptions"
                placeholder="请选择国籍"
                @search="handleSearch"
                @popupScroll="handlePopupScroll"
                @select="handleSelect"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              class="sp-lineh"
              label="性别"
              required
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <a-radio-group name="gender"
                v-decorator="[
                    'gender',
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ]
                    }
                ]">
                <a-radio value="M">
                  男
                </a-radio>
                <a-radio value="F">
                  女
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="手机号"
              required
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <a-input
                v-decorator="[
                    'mobilePhone',
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                :size="size"
                placeholder="请输入手机号"
              >
                <a-select
                  class="counrty-code-select"
                  showSearch
                  slot="addonBefore"
                  :dropdownMatchSelectWidth="false"
                  :filterOption="countryCodefilter"
                  optionLabelProp="value"
                  v-decorator="[
                  'countryCode',
                  { initialValue: '86' }
                ]"
                >
                  <a-select-option
                    v-for="(d, index) in countryCodeArr"
                    :key="index"
                    :value="d.value"
                    :data="`${d.value} ${d.label} ${d.desc} ${d.icon}`"
                  >{{d.label}}-{{d.value}}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="验证码" required :label-col="{ span: labelWidth }" :wrapper-col="{ span: wrapWidth }">
              <l8-imgcaptcha v-model="captcha" :size="'large'" ref="imgcaptcha"></l8-imgcaptcha>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item class="btn-center" style="margin-bottom: 0;">
              <a-button type="primary" size="default" @click="openCertCard">添加证件类型</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="table-wrap">
              <a-table
                rowKey="idType"
                :columns="certColumns"
                :dataSource="certList"
                :pagination="false"
              >
              <span slot="idType" slot-scope="text">
                {{ usualPassengerMap[text] }}
              </span>
              <span slot="issueCountry" slot-scope="text">
                {{ find(oriDataList, { value: text })?.label }}
              </span>
              <span slot="action" class="table-action" slot-scope="text, record, index">
                <a-button type="primary" size="small" @click="editCert(record, index)">修改</a-button>
                <a-popconfirm
                  title="是否确定删除该证件号?"
                  okText="确定"
                  cancelText="取消"
                  @confirm="() => delCert(record, index)"
                >
                  <a-button type="primary" size="small">删除</a-button>
                </a-popconfirm>
              </span>
              </a-table>
            </div>
          </a-col>

          <!-- 北美航线选填 -->
          <template v-if="airline === 'JD'">
            <h4 class="mb-10">前往美国和加拿大乘客填写</h4>
            <h5 class="mb-10">目的地暂住地址 （请务必填写英文地址，并且不能使用任何标点符号）</h5>
            <a-col :span="12">
              <a-form-item
                label="国家、州/省"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }">
                  <a-cascader
                    :field-names="{ label: 'name', value: 'code', children: 'sonList' }"
                    :options="dictionaryList"
                    placeholder="请选择国家、州/省"
                    v-decorator="[
                      `countryAndStateCodeMix`,
                      {
                        initialValue: [],
                        rules: [
                          {
                            type: 'array',
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'change'
                      }
                    ]"
                  />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                label="城市"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'city',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入城市"
                >
                </a-input>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                label="街道"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'street',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入街道"
                >
                </a-input>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                label="邮政编码"
                :label-col="{ span: labelWidth }"
                :wrapper-col="{ span: wrapWidth }"
              >
                <a-input
                  v-decorator="[
                      'zipCode',
                      {
                        rules: [
                          {
                            validator: handleFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  :size="size"
                  placeholder="请输入邮政编码"
                >
                </a-input>
              </a-form-item>
            </a-col>

          </template>

          <a-col :span="6" :offset="9">
            <a-form-item class="btn-center">
              <a-button type="primary" html-type="submit" size="default" @click="handleSubmit">提 交</a-button>
              <a href="javascript:void(0);" class="clear-form" @click="clearForm">清空</a>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-modal
        :title="`${isEdit ? '修改' : '添加'}证件信息`"
        :visible="certVisible"
        :destroyOnClose="true"
        :confirmLoading="confirmLoading"
        @cancel="handleCancel"
        @ok="onSubmitcertInfo"
      >
        <a-form :form="certForm" :label-col="{ span: labelWidth }" :wrapper-col="{ span: wrapWidth }" @submit="onSubmitcertInfo">
          <a-form-item label="证件类型" required>
            <a-select
              v-decorator="[
                  'idType',
                  {
                    rules: [
                      {
                        validator: handleCertFieldValidate
                      }
                    ],
                    validateTrigger: 'change'
                  }
                ]"
              :size="size"
              placeholder="请选择证件类型"
            >
              <a-select-option v-for="(name, key) in usualPassengerMap" :value="key" :key="key">{{ name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="证件号码" required>
            <a-input
              v-decorator="[
                'certificateNo',
                {
                  rules: [
                    {
                      validator: handleCertFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              :size="size"
              placeholder="请输入所选证件类型号码"
            />
          </a-form-item>
          <a-form-item label="证件签发地" required>
            <a-select
              v-decorator="[
                'issueCountry',
                {
                  rules: [
                    {
                      validator: handleCertFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              show-search
              :filter-option="filterOption"
              :options="renderedOptions"
              placeholder="请选择证件签发地"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
              @select="handleSelect"
            >
            </a-select>
          </a-form-item>
          <a-form-item label="证件有效期" required>
            <a-date-picker
              style="width: 100%;"
              v-decorator="[
                  'certExpried',
                  {
                    rules: [
                      {
                        validator: handleCertFieldValidate
                      }
                    ],
                    validateTrigger: 'change'
                  }
                ]"
              :size="size"
              :format="'YYYY-MM-DD'"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: wrapWidth, offset: labelWidth }">
            <a-checkbox
              v-decorator="[
                'always',
                {
                  valuePropName: 'checked',
                  initialValue: false
                }
              ]"
              @change="checkChange"
            > 长期有效
            </a-checkbox>
          </a-form-item>
        </a-form>
      </a-modal>
      <div class="mod-tip" v-if="cmsPageTips">
        <h4>{{ cmsPageTips.warmPromptTitle ?? '温馨提示' }}</h4>
        <p v-html="cmsPageTips.warmPromptContent"></p>
      </div>
    </div>
  </a-locale-provider>
</template>
<script>
import Vue from 'vue'
import { addUsualPassenger, updateUsualPassenger, delPassengerCert } from '@/apis/passenger'
import { validate } from '@/assets/js/validate'
import { LocaleProvider, Tooltip, Row, Col, Radio, Checkbox, Cascader } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import { debounce, find, findIndex, has, cloneDeep, some, partition, get } from 'lodash'
import 'moment/locale/zh-cn'
import ImgCaptcha from '@/components/imgcaptcha'
import passengerTooltip from '@/components/tooltip/passenger-tooltip'
import { usualPassengerMap } from '@/dicts/order'
import { parseToPinyin, fetchDictionaryList } from '@/apis/common'
import { getCmsDataFormat } from '@/assets/js/util'

import { regFirstCnMix } from '@/assets/js/validate/utils/name'

Vue.use(LocaleProvider)
Vue.use(Tooltip)
Vue.use(Row)
Vue.use(Col)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(ImgCaptcha)
Vue.use(Cascader)

moment.locale('zh-cn')

const certColumns = [
  {
    key: 'idType',
    title: '证件类型',
    dataIndex: 'idType',
    scopedSlots: { customRender: 'idType' },
    align: 'center'
  },
  {
    key: 'certificateNo',
    title: '证件号',
    dataIndex: 'certificateNo',
    align: 'center'
  },
  {
    key: 'issueCountry',
    title: '证件签发国/地区',
    dataIndex: 'issueCountry',
    scopedSlots: { customRender: 'issueCountry' },
    align: 'center'
  },
  {
    key: 'certExpried',
    title: '证件有效期',
    dataIndex: 'certExpried',
    align: 'center'
  },
  {
    key: 'action',
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center'
  }
]

const LOAD_NUM = 20
const certMaxExpried = '2037-12-31'

const airline = window.__MICRO_ROOT__?.airline

export default {
  props: {
    passengerId: { type: [String, Number] },
    initData: { type: Object },
    size: { type: String },
    oriDataList: { type: Array },
    passengerFieldInfo: { type: Array }
  },
  components: {
    passengerTooltip
  },
  data () {
    return {
      zhCN,
      usualPassengerMap,
      form: this.$form.createForm(this),
      captcha: '',
      labelWidth: 6,
      wrapWidth: 16,
      countryCodeArr: [],
      isSubmit: false, // 是否点击了提交按钮，用于决定是否调用fillBirthday, 如果在submit情况下调用，表单中的birhday被重写，会导致验证结果返回revalidate错误
      certColumns,
      certList: [],
      editCertIndex: null,
      editCertId: null,
      certForm: this.$form.createForm(this, { name: 'cert' }),
      confirmLoading: false,
      isEdit: false,
      certVisible: false,
      searchVal: '', // 搜索的内容
      filterDataList: [], // 过滤的数据列表 -- 从dataList中过滤出含搜索内容的数据
      renderedOptions: [], // 已渲染的下拉列表
      airline,
      cmsPageTips: null,
      dictionaryList: []
    }
  },
  watch: {
    initData: {
      handler: function (val, oldVal) {
        if (val) {
          this.updateForm(val)
        }
      },
      deep: true,
      immediate: true
    },
    oriDataList: {
      handler () {
        this.updateCountryData()
      },
      immediate: true
    }
  },
  computed: {
    initPassengerName () {
      const { passengerFirstName = '', passengerLastName = '' } = this.form.getFieldsValue()
      return passengerLastName + passengerFirstName
    }
  },
  created () {
    const t = this
    require.ensure([], (require) => {
      t.countryCodeArr = require('@/assets/js/countrycode').default
    })

    if (this.airline === '9H') {
      const list = Object.entries(usualPassengerMap).filter(([key]) => { return !['NI', 'HM'].includes(key) })
      this.usualPassengerMap = Object.fromEntries(list)
    }
    this.getCmsData()
  },
  mounted () {
    if (this.initData.id) {
      this.updateForm(this.initData)
    }
    this.fetchDictionaryListByApi()
  },
  methods: {
    find,
    async getCmsData () {
      const cmsData = await getCmsDataFormat()
      this.cmsPageTips = get(cmsData, 'tips') ?? null
    },
    updateCountryData () {
      this.renderedOptions = this.oriDataList.slice(0, LOAD_NUM)
      this.$nextTick(() => {
        this.form.setFieldsValue({ nationality: 'CN' })
      })
    },
    updateForm (passenger) {
      this.isSubmit = false
      if (passenger.id) {
        const { zipCode, city, street, countryCode, provinceCode } = passenger?.passengerAddressList?.[0] ?? ''
        this.$nextTick(() => {
          this.form.setFieldsValue({
            passengerName: passenger.passengerName,
            passengerLastName: passenger.surnameCn,
            passengerFirstName: passenger.nameCn,
            firstName: passenger.firstName,
            lastName: passenger.lastName,
            nationality: passenger.nationality || undefined,
            gender: passenger.gender,
            passengerType: passenger.passengerType,
            mobilePhone: passenger.telephoneNo,
            birthday: moment(passenger.birthday),
            zipCode,
            city,
            street,
            countryAndStateCodeMix: [countryCode, provinceCode]
          })
        })
        this.certList = cloneDeep(passenger.passengerCards)
      } else {
        this.$nextTick(() => {
          this.clearForm()
        })
      }
    },
    showPassengerName () {
      const flag = some(this.certList, cItem => {
        return ['NI', 'HM', 'ID26'].includes(cItem.idType)
      })

      return flag
    },
    showSplitName () {
      const intCertList = partition(this.certList, cItem => {
        return ['NI', 'HM', 'ID26'].includes(cItem.idType)
      })[1]

      return !this.certList?.length || !!intCertList?.length
    },
    clearForm () {
      this.form.resetFields()
      this.certList = []
    },
    handleFieldValidate (rule, value, callback) {
      let formValues = this.form.getFieldsValue()
      if (rule.fullField === 'birthday') {
        let birthday = formValues.birthday
        if (birthday) {
          birthday = birthday.format()
          birthday = birthday.split('T')[0]
          formValues.birthday = birthday
        }
      }
      validate('usualPassenger', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    handleCertFieldValidate (rule, value, callback) {
      let formValues = this.certForm.getFieldsValue()
      validate('usualPassenger', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          if (rule.fullField === 'certificateNo' && formValues.idType === 'NI') {
            this.fillBirthday(formValues.certificateNo)
          }
          // 校验是否满16周岁，超过不能使用户口簿
          // if (rule.fullField === 'certificateNo' && formValues.idType === 'ID16') {
          //   const isOverSixteenFlag = this.isOverSixteen(formValues.certificateNo)
          //   if (!isOverSixteenFlag) {
          //     const errorContent = '年满16周岁的乘客，请选择除户口簿外的其他有效证件！'
          //     callback(errorContent)
          //   }
          // }
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.isSubmit = true //
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!this.captcha) {
            this.$message.error('请填写正确的图片验证码')
            return
          }
          const { passengerLastName, passengerFirstName, lastName, firstName, passengerName, countryAndStateCodeMix, city, street, zipCode } = values

          if (this.showSplitName()) {
            if (!passengerLastName && !passengerFirstName && !lastName && !firstName) {
              this.$message.error('中文和英文姓名必须填一个')
              return
            }

            if ((!passengerLastName && passengerFirstName) || (passengerLastName && !passengerFirstName)) {
              this.$message.error('请补全中文姓名')
              return
            }

            if ((!lastName && firstName) || (lastName && !firstName)) {
              this.$message.error('请补全英文姓名')
              return
            }
          }

          if (this.showPassengerName()) {
            if (!regFirstCnMix.test(passengerName)) {
              this.$message.error('姓名仅支持中文或中文+拼音')
              return
            }
          }

          if (!this.certList.length) {
            this.$message.error('请至少添加一条证件信息')
            return
          }

          let params = Object.assign({}, values)
          let birthday = params.birthday
          if (birthday) {
            birthday = birthday.format()
            birthday = birthday.split('T')[0]
            params.birthday = birthday
          }
          params.captcha = this.captcha
          params.passengerCards = []
          if (passengerLastName && passengerFirstName) {
            params.passengerName = passengerLastName + passengerFirstName
          } else if (lastName && firstName) {
            if (!params.passengerName) {
              params.passengerName = lastName + '/' + firstName
            }
          }
          params.surnameCn = passengerLastName
          params.nameCn = passengerFirstName
          params.destCountryCode = countryAndStateCodeMix?.[0]
          params.destStateCode = countryAndStateCodeMix?.[1]
          params.destCity = city
          params.destAddress = street
          params.destZipCode = zipCode
          if (this.initData?.passengerAddressList?.[0]?.id) {
            params.destid = this.initData.passengerAddressList[0].id
          }

          delete params.countryAndStateCodeMix
          delete params.city
          delete params.street
          delete params.zipCode
          delete params.passengerFirstName
          delete params.passengerLastName

          // 用于判断证件类型选择身份证和户口簿时，证件号码和出生日期是否一致
          for (let i = 0; i < this.certList.length; i++) {
            let cItem = this.certList[i]

            if (['NI'].includes(cItem.idType)) {
              if (this.fillBirthday(cItem.certificateNo, true) !== params.birthday) {
                this.$message.error(`出生日期与${usualPassengerMap[cItem.idType]}不一致`)
                return
              }
            }

            params.passengerCards.push({
              id: cItem.id,
              idType: cItem.idType,
              certificateNo: cItem.certificateNo,
              issueCountry: cItem.issueCountry,
              certExpried: cItem.certExpried
            })
          }
          if (this.initData.id) {
            params.id = this.initData.id
            params.cardId = this.initData.cardId
            try {
              await updateUsualPassenger(params)
              this.$message.success('修改乘机人成功！')
              this.$emit('addPassenger')
            } catch (e) {
              this.$message.error(e.message)
              this.$refs.imgcaptcha.refresh()
            }
          } else {
            try {
              await addUsualPassenger(params)
              this.$message.success('添加乘机人成功！')
              this.$emit('addPassenger')
            } catch (e) {
              this.$message.error(e.message)
              this.$refs.imgcaptcha.refresh()
            }
          }
        } else {
          console.log(err)
          this.$refs.imgcaptcha.refresh()
        }
      })
    },
    /**
     * 根据身份证号获取生日
     */
    fillBirthday (idCard, isReturn = false) {
      let birth = ''
      if (idCard.length === 15) {
        birth = idCard.slice(6, 12)
        birth = '19' + birth
      } else if (idCard.length === 18) {
        birth = idCard.slice(6, 14)
      }
      const birthday = birth.slice(0, 4) + '-' + birth.slice(4, 6) + '-' + birth.slice(6, 8)
      const birthFormat = moment(birthday, 'YYYY-MM-DD')
      if (!isReturn) {
        this.form.setFieldsValue({
          birthday: birthFormat
        })
      } else {
        return birthday
      }
    },
    /**
     * 判断是否超过16周岁，用于校验证件类型为户口簿
     */
    isOverSixteen (idCard) {
      const birthFormat = moment(this.fillBirthday(idCard, true), 'YYYY-MM-DD')
      const currentFormat = moment(new Date(), 'YYYY-MM-DD')
      const diffYears = currentFormat.diff(birthFormat, 'years')
      return !(diffYears >= 16)
    },
    clearBirthday () {
      let birthFormat = moment()
      this.form.setFieldsValue({
        birghday: birthFormat
      })
    },
    countryCodefilter (input, option) {
      return option.data.attrs.data.toLowerCase().indexOf(input) >= 0
    },
    onNameChange (e, key, toKey) {
      this.form.validateFields([key], (errors, values) => {
        if (!errors) {
          const { passengerFirstName = '', passengerLastName = '' } = this.form.getFieldsValue()
          this.form.setFieldsValue({
            passengerName: passengerLastName + passengerFirstName
          })
          this.toPinyin(e.target.value, toKey, 'form')
        }
      })
    },
    onPTypeChange () {
      this.form.validateFields(['birthday'], (errors, values) => {})
    },
    async toPinyin (value, type, form) {
      try {
        const data = await parseToPinyin({
          value
        })

        this[form].setFieldsValue({ [type]: data.toLocaleUpperCase() })
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    openCertCard () {
      this.isEdit = false
      this.certVisible = true
      this.$nextTick(() => {
        if (this.airline !== '9H') {
          this.certForm.setFieldsValue({
            idType: 'NI',
            issueCountry: 'CN'
          })
        }
      })
    },
    editCert (record, index) {
      const { id, idType, certificateNo, issueCountry, certExpried } = record

      this.editCertId = id
      this.isEdit = true
      this.certVisible = true
      this.editCertIndex = index
      this.$nextTick(() => {
        this.certForm.setFieldsValue({
          idType,
          certificateNo,
          issueCountry,
          certExpried,
          always: certExpried === certMaxExpried
        })
      })
    },
    async delCert (record, index) {
      const { id } = record

      if (id) {
        let conuthasIdItem = 0
        this.certList.forEach(item => {
          if (has(item, 'id')) {
            conuthasIdItem++
          }
        })
        if (conuthasIdItem === 1) {
          this.$modal.confirm({
            title: '提示',
            content: '确定删除最后一个已提交保存的证件吗？这将会删除该条乘机人信息',
            cancelText: '取消',
            okText: '确认',
            onOk: () => {
              this.delFun(id)
            }
          })
        } else {
          this.delFun(id)
        }
      } else {
        this.certList.splice(index, 1)
      }
    },
    async delFun (id) {
      try {
        await delPassengerCert({
          passengerId: this.passengerId,
          cardId: id
        })

        this.certVisible = false
        this.$emit('addPassenger')
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    checkChange (e) {
      let certExpried = ''
      if (e.target.checked) {
        certExpried = moment(certMaxExpried)
      }
      this.certForm.setFieldsValue({
        certExpried
      })
    },
    onSubmitcertInfo () {
      this.certForm.validateFields((err, values) => {
        if (!err) {
          let certValues = Object.assign({}, values)
          const certIndex = findIndex(this.certList, ['idType', certValues.idType])

          certValues.certExpried = moment(values.certExpried).format('YYYY-MM-DD')
          if (this.isEdit) {
            if (this.editCertId) certValues.id = this.editCertId
            if (this.certList[this.editCertIndex].idType === certValues.idType || certIndex === -1) {
              this.$set(this.certList, this.editCertIndex, certValues)
            } else {
              this.$message.error('您已添加过该证件类型！')
              return
            }
          } else {
            if (certIndex > -1) {
              this.$message.error('您已添加过该证件类型！')
              return
            }
            this.certList.push(certValues)
          }
          this.certVisible = false
        }
      })
    },
    handleCancel () {
      this.certVisible = false
    },
    getPassengerFieldInfo (type) {
      const { passengerFieldInfo = [] } = this
      const data = passengerFieldInfo.find(item => { return item?.label === type }) || null
      return data
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    // 懒加载优化 select 数据过大产生的卡顿
    // 文本框值变化时触发 -- 从数据源中过滤出含搜索内容的数据，并取过滤结果的前n条作为下拉列表的可选项
    handleSearch (val) {
      const { oriDataList } = this
      const filterList = val ? oriDataList.filter(item => { return item.label.indexOf(val) > -1 }) : oriDataList
      this.searchVal = val
      this.filterDataList = filterList
      this.renderedOptions = filterList.length < LOAD_NUM ? filterList : filterList.slice(0, LOAD_NUM)
    },

    // 滚动时触发（防止抖动）
    handlePopupScroll: debounce(function () {
      const { searchVal, oriDataList, filterDataList } = this
      this.loadMoreData(searchVal === '' ? oriDataList : filterDataList)
    }, 400),

    // 加载更多数据到select框
    loadMoreData (dataList) {
      const renderedLen = this.renderedOptions.length // 已渲染的下拉列表长度
      const totalLen = dataList.length // 当前数据源的长度
      if (renderedLen < totalLen) {
        const addList = renderedLen + LOAD_NUM <= totalLen
          ? dataList.slice(renderedLen, renderedLen + LOAD_NUM)
          : dataList.slice(renderedLen, renderedLen + (totalLen % LOAD_NUM))
        this.renderedOptions = (this.renderedOptions).concat(addList)
      }
    },
    // 被选中时调用，参数为选中项的 value (或 key) 值
    handleSelect (val) {
      if (this.searchVal) {
        const selectedArr = this.oriDataList.filter(item => item.value === val) // 从数据源中过滤出下拉框选中的值，并返回一个数组
        const restList = this.oriDataList.filter(item => item.value !== val) // 从数据源中过滤出其他的值，返回一个数组
        const newList = selectedArr.concat(restList).slice(0, LOAD_NUM) // 将选中的元素放到下拉列表的第一位
        this.renderedOptions = newList // 更新已渲染的下拉列表
        this.searchVal = '' // 因为触发handleSelect函数时，会自动清空用户输入的内容。因此，searchVal需要重置。
      }
    },
    async fetchDictionaryListByApi () {
      const params = {
        'groupCode': 'PA',
        'parentCode': '0',
        'loadData': 'all',
        'dicTag': 'north-america'
      }
      this.dictionaryList = await fetchDictionaryList(params)
    }
  }
}
</script>
<style lang="less" scoped>
.mb-10 {
  margin-bottom: 10px;
}
::v-deep .ant-form-explain {
  margin-top: 0;
}
.add-passenger {
  .ant-form-item {
    min-height: 61px;
  }
  .sp-lineh {
    ::v-deep .ant-form-item-control {
      line-height: 53px;
    }
  }
  .table-wrap {
    margin-bottom: 20px;
  }
  .btn-center {
    text-align: center;
  }
  .table-action {
    .ant-btn {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  a.clear-form {
    display: inline-block;
    margin-left: 30px;
    color: @primary-color;
    text-decoration: underline;
  }
  .ant-input.ant-input-lg {
    margin-bottom: 0;
  }

  ::v-deep .ant-input.ant-cascader-input {
    padding: 20px 14px;
    height: 52px;
  }
}
.l8-tooltip {
  max-width: 324px;

  .ant-tooltip-arrow {
    border-right-color: #fff;
  }

  .ant-tooltip-inner {
    line-height: 24px;
    background-color: #fff;
    color: #888;
  }
}

.mod-tip {
  h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
  }
  h4, p {
    color: #666;
  }
}

</style>
